
/* Ametistikissa – Mega Menu Hover + Fast Image Preloading */
(() => {
  if (window.__akMegaHoverInit) return;
  window.__akMegaHoverInit = true;

  const desktop = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );

  const imageCache = new Map();

  function preloadImage(src) {
    if (!src) return Promise.resolve(false);

    if (imageCache.has(src)) {
      return imageCache.get(src);
    }

    const promise = new Promise(resolve => {
      const img = new Image();

      img.onload = async () => {
        try {
          if (img.decode) await img.decode();
        } catch (e) {}

        resolve(true);
      };

      img.onerror = () => resolve(false);
      img.src = src;
    });

    imageCache.set(src, promise);
    return promise;
  }

  function init() {
    document.querySelectorAll('.ak-header-nav').forEach(nav => {
      if (nav.dataset.akHoverReady) return;

      nav.dataset.akHoverReady = 'true';

      const menus = [
        ...nav.querySelectorAll('details.mega-menu')
      ];

      let closeTimer;

      function closeAll(except = null) {
        menus.forEach(menu => {
          if (menu === except) return;

          menu.removeAttribute('open');

          menu.querySelector('summary')
            ?.setAttribute('aria-expanded', 'false');
        });
      }

      // Collection preview images
      nav.querySelectorAll('.ak-unified-mega').forEach(menu => {
        const panel = menu.querySelector('.ak-mega__visual');
        const picture = panel?.querySelector('.ak-mega__preview-img');
        const empty = panel?.querySelector('.ak-mega__preview-empty');

        if (!panel || !picture) return;

        const originalSrc = picture.getAttribute('src') || '';
        const originalAlt = picture.getAttribute('alt') || '';

        const links = [
          ...menu.querySelectorAll('a[data-ak-preview]')
        ];

        let requestId = 0;

        // Start loading images when menu opens
        function warmImages() {
          const urls = [
            originalSrc,
            ...links.map(link => link.dataset.akPreview)
          ].filter(Boolean);

          [...new Set(urls)].forEach(src => {
            preloadImage(src);
          });
        }

        async function show(link) {
          const id = ++requestId;
          const src = link?.dataset.akPreview || originalSrc;

          if (!src) {
            picture.hidden = true;
            if (empty) empty.hidden = false;
            return;
          }

          const loaded = await preloadImage(src);

          if (id !== requestId) return;

          if (!loaded) {
            picture.hidden = true;
            if (empty) empty.hidden = false;
            return;
          }

          if (picture.getAttribute('src') !== src) {
            picture.setAttribute('src', src);
          }

          picture.alt = link?.dataset.akPreview
            ? link.textContent.trim()
            : originalAlt;

          picture.hidden = false;

          if (empty) empty.hidden = true;
        }

        menu.addEventListener('pointerenter', event => {
          if (!desktop.matches || event.pointerType !== 'mouse') {
            return;
          }

          warmImages();
        });

        links.forEach(link => {
          link.addEventListener('pointerenter', () => {
            show(link);
          });

          link.addEventListener('focus', () => {
            show(link);
          });
        });

        menu.querySelector('.custom-mega-menu__columns')
          ?.addEventListener('pointerleave', () => {
            show(null);
          });

        menu.addEventListener('focusout', event => {
          if (!menu.contains(event.relatedTarget)) {
            show(null);
          }
        });
      });

      // Desktop hover navigation
      menus.forEach(menu => {
        const summary = menu.querySelector('summary');

        menu.addEventListener('pointerenter', event => {
          if (!desktop.matches ||
              event.pointerType !== 'mouse') return;

          clearTimeout(closeTimer);

          closeAll(menu);

          menu.setAttribute('open', '');

          summary?.setAttribute('aria-expanded', 'true');
        });

        menu.addEventListener('pointerleave', event => {
          if (!desktop.matches ||
              event.pointerType !== 'mouse') return;

          clearTimeout(closeTimer);

          closeTimer = setTimeout(() => {
            if (
              !menu.matches(':hover') &&
              !menu.contains(document.activeElement)
            ) {
              closeAll();
            }
          }, 220);
        });

        menu.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            closeAll();
            summary?.focus();
          }
        });
      });

      nav.addEventListener('pointerleave', event => {
        if (!desktop.matches ||
            event.pointerType !== 'mouse') return;

        clearTimeout(closeTimer);

        closeTimer = setTimeout(() => {
          if (!nav.contains(document.activeElement)) {
            closeAll();
          }
        }, 260);
      });

      document.addEventListener('pointerdown', event => {
        if (!nav.contains(event.target)) {
          closeAll();
        }
      });

      desktop.addEventListener('change', () => {
        closeAll();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
